var GlobalConstants = {
  goBoostPartnersBaseUrl: 'http://localhost:8080',
  matomoScriptUrl:'//hello-staging.goboost.io/',
  ctmAccountId: '209678',
};
module.exports = GlobalConstants;